<template>
  <v-container fluid class="px-0 px-md-1" align="center">
    <p class="text-h5 ml-12 mt-5 font-weight-black">検索結果</p>
    <v-row class="mt-5">
      <v-tabs class="mt-5">
        <v-tab class="font-weight-bold" @change="(e) => sort(e, '-created_at')">新着順</v-tab>
        <v-tab class="font-weight-bold" @change="(e) => sort(e, '-lgtm_count')">人気順</v-tab>
        </v-tabs>
      <template v-if="loading">
        <v-row justify="center" align-content="center" class="mt-10">
          <img src="../../../assets/loading.gif">
        </v-row>
      </template>
      <template v-else-if="topics.length > 0">
        <v-row class="" justify="center" align-content="center">
          <v-col
            v-for="(item, i) in topics"
            :key="i"
            class="px-4 mt-2"
          >
          <v-row justify="center" class="mt-2">
            <v-card
              class="mx-auto d-flex flex-column"
              width="300"
              height="369"
              outlined
            >
              <router-link 
                :to="{ name: 'topic', params: { topic_code: item.topic_code }}" 
                style="text-decoration: none;"
              >
                <v-img
                  class="white--text align-end"
                  style="height:170px"
                  :src="`${bucketUrl}${item.topic_image_url}`"
                >
                </v-img>
              </router-link>

              <router-link 
                :to="{ name: 'user', params: { user_code: item.user_code }}" 
                style="text-decoration: none; color: inherit;"
              >
                <v-card-subtitle class="pb-2 user-title">
                  <v-avatar size="24" depressed>
                    <v-img :src="item.icon_url" width="24" height="24"></v-img>
                  </v-avatar>
                  <span class="ml-2 font-weight-bold">{{ item.user_name }}</span>
                </v-card-subtitle>
              </router-link>
              <v-card-text class="pt-0 overflow-auto">
                <router-link
                  :to="{ name: 'topic', params: { topic_code: item.topic_code } }"
                  class="font-weight-bold pt-0 mb-2"
                  style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-decoration: none;
                    color: black;
                  "
                >{{ item.topic_name }}</router-link>
                <span v-for="tag in item.tags.slice(0, 3)" :key="tag.tag_name" class="mr-2">
                  <v-btn
                    depressed
                    dark
                    color="#333333"
                    @click="searchTag(tag.tag_name)"
                    x-small
                    class="font-weight-bold tag-name"
                    style="text-transform: none"
                  >{{ tag.tag_name }}</v-btn>
                </span>
              </v-card-text>

              <v-spacer></v-spacer>
              <v-divider class=""></v-divider>
              <v-card-text class="pa-1">
                <v-row class="">
                  <v-col cols="6" class="topic-updated-at" style="color: black; font-size: 10px;">
                    <time :datetime="formatDate(item.updated_at)">更新日：{{ formatDate(item.updated_at) }}</time>
                  </v-col>
                  <v-col cols="3" class="topic-preview-count" style="color: black; font-size: 14px;">
                    <v-icon size="16">mdi-eye</v-icon><span class="ml-1">{{ item.preview_count }}</span>
                  </v-col>
                  <v-col cols="3" class="topic-preview-count" style="color: black; font-size: 14px;">
                    <v-icon size="16">mdi-heart</v-icon><span class="ml-1">{{ item.lgtm }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <p class="ml-10 mt-5">検索結果はありません</p>
      </template>
    </v-row>
    <v-row class="mt-5 mx-16" justify="end">
      <v-pagination
        class="my-5"
        v-model= "crrent"
        :length= page
        @input = "getNumber"
        circle
        color = "#5E00BC"
        :total-visible="7"
      ></v-pagination>
    </v-row>
  </v-container>
</template>
<script>
import dayjs from 'dayjs'
import axios from 'axios'

export default {
  name: 'SearchTopicList',
  data() {
    return {
      topics: [],
      total_count: 0, // トピック総件数
      page: 0, // 表示ページ数
      crrent: 1, // 現在ページ
      column: "-created_at",
      sort_label : "新着順",
      search_word: '',
      search_cate: '',
      loading: true,
      tag: '',
      bucketUrl: process.env.VUE_APP_IMAGE_BUCKET_URL
    }
  },
  methods: {
    searchTag($tag) {
      // 同じurl(クエリも含めたfullpath)に遷移する際にvue.jsが警告してくれているので握りつぶしている
      this.$router.push({ path: '/search_result', query: { tag: $tag } }).catch((error) => {
        console.log(error);
      })
    },
    async tagApi($tag) {
      await axios.get(process.env.VUE_APP_API_BASE_URL + '/topic?tag=' + $tag + '&sort=' + this.column)
      .then(response => {
        this.topics = response.data.topics
        this.total_count = response.data.total_count
        this.setPaginate(this.total_count)
        this.tag = $tag;
        this.$forceUpdate();
        this.loading = false
      })
    },
    wordApi($search) {
      axios.get(process.env.VUE_APP_API_BASE_URL + '/topic?search=' + $search + '&sort=' + this.column)
      .then(response => {
        this.topics = response.data.topics
        this.total_count = response.data.total_count
        this.search_word = $search
        this.setPaginate(this.total_count)
        this.loading = false
      })
    },
    setPaginate(totalCount) {
      this.page = Math.ceil(totalCount / 32)
    },
    getNumber(number) {
      if(this.search_cate == 'word') {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/topic?skip=' + (number - 1) * 32 + '&search=' + this.search_word )
        .then(response => {
          this.topics = response.data.topics
          this.total_count = response.data.total_count
          this.current = number
          this.loading = false
        })
      }else {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/topic?skip=' + (number - 1) * 32 + '&tag=' + this.tag )
        .then(response => {
          this.topics = response.data.topics
          this.total_count = response.data.total_count
          this.current = number
          this.loading = false
        })
      }
    },
    sort(event, column) {
      this.column = column
      if(this.search_cate == 'word') {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/topic?search=' + this.search_word + '&sort=' + this.column)
        .then(response => {
          this.topics = response.data.topics
          this.total_count = response.data.total_count
          this.setPaginate(this.total_count)
          this.crrent = 1
          this.loading = false
        })
      }else {
        axios.get(process.env.VUE_APP_API_BASE_URL + '/topic?tag=' + this.tag + '&sort=' + this.column)
        .then(response => {
          this.topics = response.data.topics
          this.total_count = response.data.total_count
          this.setPaginate(this.total_count)
          this.crrent = 1
          this.loading = false
        })
      }
    },
    formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
    async init(query) {
      if (query.search) {
        await this.wordApi(query.search)
        this.search_cate = 'word';
      }
      if (query.tag) {
        await this.tagApi(query.tag)
        this.search_cate = 'tag';
      }
    }
  },
  async created() {
    this.init(this.$route.query);
  },
  // 同じurl(クエリは違っても)への遷移ではコンポーネントの再読み込みを行わない。
  // そのため、watchでurlを監視し手動で初期化して、変更されたクエリでの検索結果を表示している
  watch: {
    $route(to) {
      this.topics = [],
      this.total_count = 0, // トピック総件数
      this.page = 0, // 表示ページ数
      this.crrent = 1, // 現在ページ
      this.column = "-created_at",
      this.sort_label  = "新着順",
      this.search_word = '',
      this.search_cate = '',
      this.loading = true,
      this.tag = '',
      this.bucketUrl = process.env.VUE_APP_IMAGE_BUCKET_URL
      this.init(to.query);
    }
  }
}
</script>

<style src="./SearchTopicList.scss" lang="scss"></style>
<style scoped>
.user-title:hover {
  background-color: #F4F4F4;
}
.tag-name:hover {
  color: #C388FF;
}
.topic-updated-at {
  padding: 12px 12px 12px 16px ;
}
.topic-preview-count {
  padding: 12px 0px 12px 0px ;
}
</style>